"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { useBookingDrawer } from "@/lib/booking-context";
import { regionFromPathname, regionPath } from "@/lib/region";

export default function LpHeader() {
  const pathname = usePathname();
  const region = regionFromPathname(pathname || "/");
  const { setOpen: setBookingOpen } = useBookingDrawer();

  return (
    <header className="relative z-50 border-b border-black/10 bg-white">
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-3 px-[clamp(1.25rem,4vw,2.5rem)] py-4 lg:py-5">
        <Link
          href={regionPath("/", region)}
          aria-label="thérapie FERTILITY"
          className="block min-w-0 shrink"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/assets/logo/logo-c.svg"
            alt="Thérapie Fertility Logo"
            width={228}
            height={25}
            className="h-6 w-auto max-[359px]:h-5 md:h-7"
          />
        </Link>
        <button
          type="button"
          onClick={() => setBookingOpen(true, "lp-header")}
          className="inline-flex h-11 shrink-0 cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-purple-03 px-5 text-[15px] font-bold text-white transition-colors hover:bg-purple-04 lg:h-12 lg:px-6 lg:text-body"
        >
          Book free consultation
        </button>
      </div>
    </header>
  );
}
